export default __webpack_public_path__ + "static/media/ic_skip_previous_48px.034ffb10.svg";